import { render } from "./ThePage.vue?vue&type=template&id=825338ba&scoped=true"
import script from "./ThePage.vue?vue&type=script&lang=js"
export * from "./ThePage.vue?vue&type=script&lang=js"

import "./ThePage.vue?vue&type=style&index=0&id=825338ba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-825338ba"]])

export default __exports__